import { render, staticRenderFns } from "./CreateThank.vue?vue&type=template&id=7e318ba2&"
import script from "./CreateThank.vue?vue&type=script&lang=js&"
export * from "./CreateThank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports